import React, {Component} from 'react';
import {OkayC} from '../../icon-library';
import Icon from '../../components/icon';
import FormField from '../../components/form-field';
import {connect} from 'react-redux';

import {refreshReducersToInitial} from '../../action';
import {generatePath, redirectNavigationUrl} from '../../utilities/RedirectUtils';
import FeedbackStarRating from '../../components/feedback-star-rating';
import {submitFeedbackSurvey} from "../../api";
import { TRANSLATION_CONSTANTS } from '../../app-consts/translations';
import { LocaleContext } from '../../contexts/LocaleContext';
import { Button } from 'mesh-component-library';
import { datadogRum } from '@datadog/browser-rum';
import { getServiceRequestPayload} from '../../selector';
import { getOmniStreamlinedFlag } from '../../features/FeatureFlags';
class Feedback extends Component {
  static contextType = LocaleContext;
  constructor(props) {
    super(props);
    this.state = {
      providerRating: 0,
      appRating: 0,
      additionalComments: "",
      isSubmitting: false
    }
  }

  componentDidMount() {
    document.title = 'Feedback | Roadside Assistance';
  }

  changeProviderRating = (newRating) => {
    this.setState({providerRating: newRating});
  }

  changeAppRating = (newRating) => {
    this.setState({appRating: newRating});
  }

  updateComment = (event) => {
    this.setState({additionalComments: event.target.value});
  }

  submitFeedbackAndRerouteUser_v1 = async () => {

    this.setState({isSubmitting: true});
    const {
      serviceRequestPayload,
      partnerDetails,
      refreshReducersToInitial,
      history,
      submitRequestCallId,
      omniStreamlined
    } = this.props;

    const nestedPartnerDetails = partnerDetails?.partnerDetails || {};
    const partnerCode = nestedPartnerDetails.partnerCode || '';
    const url = redirectNavigationUrl(nestedPartnerDetails);

    const callId = !!omniStreamlined ? serviceRequestPayload?.sessionId : submitRequestCallId;

    const feedbackRequest = {
      ratings: [
        { rating: this.state.providerRating, type: "PROVIDER" },
        { rating: this.state.appRating, type: "APP" },
      ],
      comment: this.state.additionalComments,
      requestedBy: "omniassist",
    };

    datadogRum.addAction(`Submitting feedback survey`, { partnerCode, callId });

    try {
      await submitFeedbackSurvey({ feedbackRequest, partnerCode, callId });
    } catch (error) {
      datadogRum.addError("Feedback Survey Failed", { partnerCode, callId, error });

    }
    refreshReducersToInitial();
    const tollFreeNumber = localStorage.getItem("tollFreeNumber");
    localStorage.clear();

    if (tollFreeNumber) {
      localStorage.setItem("tollFreeNumber", tollFreeNumber);
    }
    localStorage.setItem("feedbackConfirmation", "YES");

    history.push(generatePath(url));
  };


  cancelRate = () => {
    const {
      partnerDetails: {
        partnerDetails
      },
      history,
      refreshReducersToInitial
    } = this.props;
    datadogRum.addAction(`User cancelled feedback submission`, {
      displayCode: partnerDetails?.displayCode
    });
    refreshReducersToInitial();
    localStorage.clear();
    let url = redirectNavigationUrl(partnerDetails);
    history.push(generatePath(url));
  }

  render() {
    const {appRating, providerRating, additionalComments, isSubmitting } = this.state
    const getTranslatedText = this.context;
    return (
      <div role="main" className="l-container-feedback">
        <div className="l-container__header">
          <Icon icon={OkayC} color="green-light" size={3}/>
          <h1>{getTranslatedText(TRANSLATION_CONSTANTS.MISSION_ACCOMPLISHED)}</h1>
          <h4>{getTranslatedText(TRANSLATION_CONSTANTS.SHARE_YOUR_FEEBACK)}</h4>
        </div>

        <div className="l-confirmation-container l-confirmation-container_rate">
          <p>{getTranslatedText(TRANSLATION_CONSTANTS.HOW_WAS_YOUR_EXPERIENCE_RESCUER)}</p>
          <FeedbackStarRating
            rating={providerRating}
            starRatedColor="#0033a0"
            changeRating={this.changeProviderRating}
            numberOfStars={5}
            name='providerRating'
            starDimension="29px"
            hoverMode="false"
            starEmptyColor="#f5f5f5"
          />
          <p className="u-vr-4-top">{getTranslatedText(TRANSLATION_CONSTANTS.HOW_WAS_YOUR_EXPERIENCE_SITE)}</p>
          <FeedbackStarRating
            rating={appRating}
            starRatedColor="#0033a0"
            changeRating={this.changeAppRating}
            numberOfStars={5}
            name='appRating'
            starDimension="29px"
            starEmptyColor="#f5f5f5"
          />
          <FormField
            label={getTranslatedText(TRANSLATION_CONSTANTS.SHARE_ANY_ADDITIONAL_COMMENTS)}
            showCharCount
            maxLength={150}
            type="textarea"
            rows={4}
            value={additionalComments}
            onChange={this.updateComment}
            className="l-confirmation-container_rate--textarea u-vr-4-top"
          />
          <Button
            size='lg'
            hasUpgrade
            onClick={this.submitFeedbackAndRerouteUser_v1}
            disabled={appRating === 0 || providerRating === 0 || isSubmitting}
            id="submit-feedback"
            utils={{
              fullWidth: true
            }}>
            submit
          </Button>
          <button className="btn send-request c-cancelBtn"
                  onClick={this.cancelRate}>{getTranslatedText(TRANSLATION_CONSTANTS.SKIP)}
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    partnerDetails: state.partnerDetails,
    serviceInfo: state.serviceInfo,
    serviceRequestPayload: getServiceRequestPayload(state),
    omniStreamlined: getOmniStreamlinedFlag(state),
    submitRequestCallId: state?.submitRequest?.response?.callId
  };
}

export default connect(mapStateToProps, {
  refreshReducersToInitial
})(Feedback);
